
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { GruppoVenduto } from '@/models';

@Component
export default class ItemListVenduto extends Vue {
    @Prop() private item!: GruppoVenduto;
}
